var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ky-chat-main" },
    [
      _vm.chatListShow
        ? _c("div", { staticClass: "top-bar" }, [
            _c("img", {
              staticClass: "logo",
              attrs: { src: require("../../assets/kayi-logo-white.png") }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "img-text" }, [
              _c("img", {
                staticClass: "my-avatar",
                attrs: {
                  src:
                    _vm.mySelfData.user && _vm.mySelfData.user.avatarImageUrl
                      ? _vm.mySelfData.user.avatarImageUrl
                      : require("../../../static/avatar.jpg")
                }
              }),
              _vm._v(" "),
              _c("span", [
                _vm._v(
                  _vm._s(_vm.mySelfData.user && _vm.mySelfData.user.userName)
                )
              ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "chat-main",
          style: !_vm.chatListShow ? "height:100%" : ""
        },
        [
          _c("chatList", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.chatListShow,
                expression: "chatListShow"
              }
            ],
            ref: "chatList",
            attrs: {
              allUserGroups: _vm.allUserGroups,
              clickItem: _vm.clickItem,
              myUserId: _vm.myUserId,
              pageType: _vm.pageType
            },
            on: {
              "update:clickItem": function($event) {
                _vm.clickItem = $event
              },
              "update:click-item": function($event) {
                _vm.clickItem = $event
              },
              chatClick: _vm.chatClick,
              changeGroupSetting: _vm.changeGroupSetting,
              changeGroupDelete: _vm.changeGroupDelete,
              addGroup: function($event) {
                _vm.addVisible = true
              },
              createGroup: function($event) {
                return _vm.createGroup("create")
              }
            }
          }),
          _vm._v(" "),
          _vm.contentShow
            ? _c(
                "div",
                { staticClass: "right-main flex" },
                [
                  _c(
                    "div",
                    { staticClass: "right-content" },
                    [
                      _c("div", {
                        staticClass:
                          "el-icon-arrow-left more-icon-3 cursor hide",
                        attrs: { id: "back-to-list" },
                        on: { click: _vm.backToList }
                      }),
                      _vm._v(" "),
                      _c("chatContent", {
                        ref: "chatContent",
                        attrs: {
                          clickItem: _vm.clickItem,
                          pageType: _vm.pageType,
                          myUserId: _vm.myUserId
                        },
                        on: {
                          "update:clickItem": function($event) {
                            _vm.clickItem = $event
                          },
                          "update:click-item": function($event) {
                            _vm.clickItem = $event
                          },
                          settingClick: _vm.settingClick
                        }
                      }),
                      _vm._v(" "),
                      _c("input-send", {
                        ref: "inputSend",
                        attrs: { clickItem: _vm.clickItem },
                        on: {
                          sendMsgServer: _vm.sendMsgServer,
                          historyClick: _vm.historyClick
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("history", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.historyShow,
                        expression: "historyShow"
                      }
                    ],
                    ref: "history",
                    attrs: {
                      myUserId: _vm.myUserId,
                      clickItem: _vm.clickItem,
                      historyShow: _vm.historyShow
                    },
                    on: {
                      "update:historyShow": function($event) {
                        _vm.historyShow = $event
                      },
                      "update:history-show": function($event) {
                        _vm.historyShow = $event
                      }
                    }
                  }),
                  _vm._v(" "),
                  _c("setting", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.settingShow,
                        expression: "settingShow"
                      }
                    ],
                    ref: "setting",
                    attrs: {
                      myUserId: _vm.myUserId,
                      clickItem: _vm.clickItem,
                      settingShow: _vm.settingShow
                    },
                    on: {
                      "update:settingShow": function($event) {
                        _vm.settingShow = $event
                      },
                      "update:setting-show": function($event) {
                        _vm.settingShow = $event
                      },
                      addPeopleGroup: _vm.addPeopleGroup
                    }
                  })
                ],
                1
              )
            : _c("Welcome", { staticClass: "welcome" }),
          _vm._v(" "),
          _c("addGroup", {
            ref: "addGroup",
            attrs: { addVisible: _vm.addVisible, myUserId: _vm.myUserId },
            on: {
              "update:addVisible": function($event) {
                _vm.addVisible = $event
              },
              "update:add-visible": function($event) {
                _vm.addVisible = $event
              }
            }
          }),
          _vm._v(" "),
          _c("CreateGroup", {
            attrs: {
              createVisible: _vm.createVisible,
              myUserId: _vm.myUserId,
              allUsers: _vm.allUserGroups.allUsers,
              createParams: _vm.createParams,
              clickItem: _vm.clickItem,
              pageType: _vm.pageType,
              peopleModalType: _vm.peopleModalType,
              groupPeopleData: _vm.groupPeopleData
            },
            on: {
              "update:createVisible": function($event) {
                _vm.createVisible = $event
              },
              "update:create-visible": function($event) {
                _vm.createVisible = $event
              }
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.loadingShow ? _c("loading") : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-d7de9798", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7de9798","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./packages/chat/src/index.vue
// module id = null
// module chunks = 